
<nav class="navbar">
  <div class="navbar-container">
    <a class="navbar-brand" href="#">
      <img src="assetpath" alt="Headshot" />
    </a>
    <button class="navbar-toggle" (click)="toggleMenu()">☰</button>
    <ul [class.active]="menuOpen" class="navbar-links">
      <li *ngFor="let link of links" class="nav-item" >
        <a class="nav-link custom-btn btn-13" (click)="navigate(link.path)">{{link.label}}</a>
      </li>
    </ul>
  </div>
  <div class="navbar-action-items">
    <ul *ngIf="userIsAuthenticated()" [class.active]="menuOpen" class="navbar-links">
      <li *ngFor="let link of links" class="nav-item" >
        <a class="nav-link custom-btn btn-15" (click)="navigate(link.path)">{{link.label}}</a>
      </li>
    </ul>
    <span class="nav-item" *ngIf="userIsAuthenticated(); else gotoLogin;">
      <a class="navbar-action" routerLink="">Features</a>
    </span>
  </div>
</nav>
<mll-notification></mll-notification>
<ng-template #gotoLogin>
  <a class="nav-link custom-btn btn-3" routerLink="/auth">Members Area</a>
</ng-template>